import { render, staticRenderFns } from "./relectureMoniteur.vue?vue&type=template&id=b35ffec0"
import script from "./relectureMoniteur.vue?vue&type=script&lang=js"
export * from "./relectureMoniteur.vue?vue&type=script&lang=js"
import style0 from "./relectureMoniteur.vue?vue&type=style&index=0&id=b35ffec0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports